import firebase from "firebase";

// Initialize Firebase
var config = {
    apiKey: "AIzaSyDMYpZ6cRl9XKlJXzkMCP3kCd32teJeCNc",
    authDomain: "project-5-6cea6.firebaseapp.com",
    databaseURL: "https://project-5-6cea6.firebaseio.com",
    projectId: "project-5-6cea6",
    storageBucket: "project-5-6cea6.appspot.com",
    messagingSenderId: "306855332935"
};
firebase.initializeApp(config);


export default firebase;